













 






















const node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dragId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSpotlight"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reflectionId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dragId",
        "variableName": "dragId"
      },
      {
        "kind": "Variable",
        "name": "isSpotlight",
        "variableName": "isSpotlight"
      },
      {
        "kind": "Variable",
        "name": "reflectionId",
        "variableName": "reflectionId"
      }
    ],
    "concreteType": "StartDraggingReflectionPayload",
    "kind": "LinkedField",
    "name": "startDraggingReflection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "meetingId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reflectionId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RemoteReflectionDrag",
        "kind": "LinkedField",
        "name": "remoteDrag",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dragUserId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dragUserName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSpotlight",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StartDraggingReflectionMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "StartDraggingReflectionMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "m_szZFYk8zvVZv9aqD2Y6QLA",
    "metadata": {},
    "name": "StartDraggingReflectionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "eb89912a3ef20d7d2a0fba44a33e448a";

export default node;
